import instance from "../api-provider";
import handleError from "../handleError";

export const addPatientBalanceContact = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/addPatientBalanceContact",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getPatientBalanceContact = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/getPatientBalanceContact",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const deleteTimesheet = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/deleteTimesheet",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const updatePatientBalanceSummary = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/updatePatientBalanceSummary",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const updatePatientBalanceNote = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/updatePatientBalanceNote",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const updatePatientBalanceReminder = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/updatePatientBalanceReminder",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const addPatientBalanceNote = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/addPatientBalanceNote",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getPatientBalanceNotes = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/getPatientBalanceNotes",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getPatientBalanceReminders = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/getPatientBalanceReminders",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getPatientBalances = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/getPatientBalances",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getPatientBalanceClaims = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/getPatientBalanceClaims",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// for payload
export const getTodaysStartEndDateTime = () => {
  const today = new Date();
  const month = today.getMonth() + 1;
  const date = today.getDate();
  const year = today.getFullYear();
  return {
    todaysStartDateTime: `${year}-${month}-${date}T00:00:00+0000`,
    todaysEndDateTime: `${year}-${month}-${date}T23:59:59+0000`,
  };
};
